const React = require('react')
const { useState } = require('react')
const { LoadingSpinner } = require('../loading')
const { Tabs } = require('../tabs')
const { UnverifiedContract } = require('./unverified.contract')
const { VerifiedContract } = require('./verified.contract.js')
const { ReadContract } = require('./read.contract')
const { WriteContract } = require('./write.contract')

require('@styles/pages/address/contract.address.css')

const ContractTab = props => {
    const { loading, data } = props

    const [activeTab, setActiveTab] = useState(() => {
        const urlHash = window.location.hash.slice(1)
        return urlHash || 'code'
    })

    return (
        <div className='box table-section'>
            {loading ? (
                <div className='d-flex justify-content-center align-items-center' style={{ height: '300px' }}>
                    <LoadingSpinner />
                </div>
            ) : (
                <>
                    {data?.information.contract.sourceCode ? (
                        <>
                            <Tabs
                                activeTab={activeTab}
                                items={[
                                    { tab: 'code', text: 'Code' },
                                    { tab: 'readContract', text: 'Read Contract' },
                                    { tab: 'writeContract', text: 'Write Contract' }
                                ]}
                                onTabChange={setActiveTab}
                            />
                            {activeTab === 'code' && <VerifiedContract data={data} />}
                            {activeTab === 'readContract' && <ReadContract data={data} />}
                            {activeTab === 'writeContract' && <WriteContract data={data} />}
                        </>
                    ) : (
                        <UnverifiedContract data={data} />
                    )}
                </>
            )}
        </div>
    )
}

module.exports = { ContractTab }
